import React from 'react';
import { Link } from 'react-router-dom';
import MeusCursosTable from '../common/tables/meus-cursos-table';

const MeusCursosArea = () => {
  return (
    <>
      <section className="blog__area pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12">
              <div className="blog__wrapper">
                <div className="blog__text mb-40">
                
                {/* <ul className="nav nav-tabs" id="courseTab" role="tablist">
                <li className="nav-item" role="presentation">
                <button className="nav-link active" id="description-tab" data-bs-toggle="tab" data-bs-target="#description" type="button" role="tab" aria-controls="description" aria-selected="true"> <i className="icon_ribbon_alt"></i> <span>Descrição</span> </button>
                </li>
                </ul> */}

                <h2 className="section__title">Meus cursos</h2>

                  {/* table */}
                  
                  <MeusCursosTable />

                  {/* table */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MeusCursosArea;